import React from 'react'
import { useIntl } from 'react-intl'

import { useRecoilValue, useRecoilCallback } from 'recoil'

import styled from '@emotion/styled'

import { Pagination, Select } from 'mailup-web-components'

import {
  modalBeeContentDialogResultsState,
  modalBeeContentDialogContentsState
} from '../recoil/state'

import { modalContentDialogSearchCallback } from '../recoil/callbacks'

const PaginationWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const StyledSelect = styled(Select)`
  &.e-select {
    width: 150px;
  }

  & .e-select__search {
    padding-top: 0;
    padding-bottom: 0;
  }

  & .e-select__selected-item--single {
    font-size: 13px;
    color: var(--boulder);
  }
`

const SearchContentsPagination = () => {
  const intl = useIntl()
  const { items, pageNumber, pageSize, totalItems } = useRecoilValue(
    modalBeeContentDialogResultsState
  )
  const { fetching } = useRecoilValue(modalBeeContentDialogContentsState)

  const searchCallback = useRecoilCallback(modalContentDialogSearchCallback, [])

  const handleChangePage = v => searchCallback({ pageNumber: v })

  const handleChangePageSize = v =>
    searchCallback({ pageNumber: 1, pageSize: v })

  return !fetching && items.length ? (
    <PaginationWrapper>
      <Pagination
        page={pageNumber}
        pageSize={pageSize}
        totalCount={totalItems}
        onChange={handleChangePage}
        formatValues={intl.formatNumber}
      />
      {totalItems > 5 && (
        <StyledSelect
          value={pageSize}
          options={[5, 10, 20, 50].map(o => ({
            label: `${o} ${intl.formatMessage({ id: 'Load.Pager.Items' })}`,
            value: o
          }))}
          onChange={handleChangePageSize}
          searchable={false}
        />
      )}
    </PaginationWrapper>
  ) : null
}

export default SearchContentsPagination
